import React, { useState } from 'react';
import { useTheme } from '../../lib/useTheme';
import { glassCard, font, C } from '../shared/constants';

export default function Faq({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div onClick={() => setOpen(!open)} style={{
      ...glassCard,
      border: open ? '1px solid rgba(93,193,185,0.4)' : '1px solid rgba(255,255,255,0.1)',
      borderRadius: 14, padding: '16px 18px', cursor: 'pointer',
      boxShadow: open ? '0 0 40px rgba(93,193,185,0.3)' : 'none',
      transition: 'box-shadow 0.3s, border 0.3s',
    }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <p style={{ fontSize:15, fontWeight:500, margin:0, fontFamily:font, color:'#fff' }}>{q}</p>
        <span style={{ fontSize:20, color:C.turquesa, transition:'transform 0.3s', display:'inline-block', transform: open ? 'rotate(45deg)' : 'none' }}>+</span>
      </div>
      {open && <p style={{ fontSize:14, color:'rgba(255,255,255,0.6)', lineHeight:1.7, margin:'12px 0 0', fontFamily:font }}>{a}</p>}
    </div>
  );
}
